import { NavigationCallback } from './step.type';
import { RouteIds } from './route-ids.enum';

/**
 * Represents the type of navigation bar item.
 */
export interface NavigationBarItem {
  /**
   * Text of the item.
   */
  label?: string;

  /**
   * Icon of the item.
   */
  icon?: string;

  /**
   * When set as true, disables the item.
   */
  disabled?: boolean;

  /**
   * The router link to navigate to.
   */
  routerLink?: string;

  /**
   * External link to navigate when item is clicked.
   */
  command?: NavigationCallback;
}

/**
 * Type for define the available steps in the navigation bar.
 */
export type AvailableStepsInNavigationBar = RouteIds.course | RouteIds.extras | RouteIds.applicant | RouteIds.quote | RouteIds.ayaQuote;
